import React, { useCallback, useEffect, useRef, useState } from 'react';
import config from './otherRules.json';
import { SLowcodeList } from 'shj-components'
import { message, Drawer, Space, Button, Badge } from 'antd';
import OtherRulesExpandTable from './otherRulesExpandTable';
import { isNil } from 'lodash-es';
import { ruleConfigSearchList, ruleConfigDtlQuoteCheckData, receiptRuleState } from '@/services/integrationConfig'
interface dataProps {
  open: boolean;
  showMode?: 'drawer' | 'modal'; //呈现方式
  config: any;
  type?: 'radio' | 'checkbox'; //多选/单选
  selectedRowKeys?: any[]; //回显的key
  selectedRow?: any[]; //回显的行数据(row)
  title?: string | JSX.Element;
  width?: number;
  mask?: boolean; //是否展示遮罩
  maskClosable?: boolean; //点击蒙层是否允许关闭
  onOk: (rows?: any) => void; //点击确定回调
  onCancel: () => void; //点击遮罩层或右上角叉或取消按钮的回调 modal
}

const OtherRules: React.FC<dataProps> = (props) => {
  const { open, showMode = 'drawer', type = 'radio', title, width, onOk, onCancel, config: configForm } = props;
  const listRef = useRef<any>();
  const [subRuleSelectedRows, setSubRuleSelectedRows] = useState([]);
  // const history = useHistory();

  useEffect(() => {
    if (open) {
      reloadFn();
    }
    if (!open) {
      listRef?.current?.resetSearch();
    }
  }, [open]);

  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const search = { ...rest.query, status: true };
        const { id: subRuleId } = configForm.getFieldsValue();
        if (!isNil(subRuleId)) {
          search.ruleConfigDtlId = subRuleId;
        }
        const data = await ruleConfigSearchList(current, pageSize, search);
        const { records, total } = data;
        resolve({ records, total });
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  const getStatusOptions = () => {
    return new Promise((resolve, reject) => {
      resolve({
        statusList: [
          {
            key: true,
            title: '启用',
          },
          {
            key: false,
            title: '禁用',
          },
        ],
      });
    });
  };

  const onEdit = (record: any) => {
    console.log(record);
    add(record);
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  // const look = (obj = {}) => {
  //   const {
  //     current: { reload },
  //   } = listRef;
  //   ruledDetailedFn({
  //     fn: () => {
  //       reload();
  //     },
  //     ...obj,
  //   });
  // };

  const edit = (obj: object) => {
    // add(obj);
  };
  const onSave = useCallback((values, dialogDestroy) => { }, []);
  const onAdd = useCallback(() => {
    add();
  }, [onSave]);
  const onDisable = useCallback(({ record, rows, selectedRows } = {}) => {
    const list = [];
    for (let m of selectedRows) {
      list.push(m.id);
    }
    receiptRuleState({ ids: list, state: 2 }).then((response: any) => {
        message.success(response?.message || '操作成功');
        reloadFn();
    });
  }, []);

  const _onOk = () => {
    if (subRuleSelectedRows.length < 1) {
      message.warning('请先选择数据!');
      return;
    }
    const { id } = subRuleSelectedRows[0];

    ruleConfigDtlQuoteCheckData(id).then((response: any) => {
      // if (isNil(response)) {
      //   onOk && onOk(subRuleSelectedRows);
      // } else {
      //   message.warning(response?.message || '操作成功');
      // }
      if (response?.message) {
        onOk && onOk(subRuleSelectedRows);
      }else{
        message.warning(response);
      }
    });
  };

  const setRowsData = (rows?: any) => {
    console.log(rows);
    setSubRuleSelectedRows(rows);
  };
  //子表格
  const expandedRowRender = (record: any, a: any, b: any, c: boolean) => {
    return (
      <OtherRulesExpandTable
        setSelectedRows={setRowsData}
        clueId={record.id}
        listRef={listRef}
        open={open}
        list={record.ruleConfigDtlList || []}
      />
    );
  };
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, onDisable },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      statusCell(text: any) {
        return (
          <div>
            {text ? (
              <>
                <Badge status="success" />
                启用
              </>
            ) : (
              <>
                <Badge status="error" />
                禁用
              </>
            )}
          </div>
        );
      },
    },
  };
  return (
    <Drawer
      visible={open}
      title={title || '数据选择'}
      width={width || 860}
      onClose={onCancel}
      extra={
        <Space>
          <Button onClick={onCancel}>关闭</Button>
          <Button onClick={() => _onOk()} type="primary">
            确定
          </Button>
        </Space>
      }
    >
      <SLowcodeList
        config={{ ...config, tableType: 'antd' }}
        expandable={{ expandedRowRender }}
        ref={listRef}
        {...extension}
      />
    </Drawer>
  );
};
export default OtherRules;
